import { gql } from '@apollo/client'

export const GET_EXTERNAL_WORK_ORDER = gql`
  query GetExternalWorkOrder($orgSlug: String!, $id: String!) {
    externalWorkOrder(orgSlug: $orgSlug, id: $id) {
      id
      orgSlug
      workOrderNumber
      description
      status
      externalAircraftId
      customerId
      usageLogId
      startedAt
      completedAt
      notes
      vendor
      shop
      assigneeId
      createdAt
      updatedAt
      aircraft {
        id
        tailNumber
        model
        make
        serialNumber
        description
        components {
          id
          name
          partNumber
          serialNumber
          description
        }
      }
      customer {
        id
        name
        email
        phoneNumber
      }
      assignee {
        id
        firstName
        lastName
        email
      }
      usageLog {
        id
        usageAsOf
        ExternalComponentUsageLog {
          id
          hours
          cycles
          component {
            id
            name
          }
        }
      }
      workItems {
        id
        title
        description
        status
        estimatedHours
        actualHours
        trackedBy
        notes
        startedAt
        completedAt
        assigneeId
        createdAt
        updatedAt
        assignee {
          id
          firstName
          lastName
          email
        }
        trackedByComponent {
          id
          name
          partNumber
          serialNumber
          description
        }
      }
    }
  }
`
